import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface LoadingScreenProps {
  secondLine?: string;
  error?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ secondLine, error }) => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#faf5ff',
        px: 2,
      }}
    >
      <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h4" align="center">
          Patient Connect
        </Typography>
        <LinearProgress sx={{ width: '100%', mt: 1 }} />        
        {secondLine && (
          <Typography variant="h4" align="center" sx={{ mt: 2 }}>
            {secondLine}
          </Typography>
        )}
        {error && (
          <Typography variant="body2" align="center" color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
